import { useTranslation } from "react-i18next";
import image from '../../img/Accounts/cards.png';

const cards = [
    {
        subtitle: 'accounts.cards.card_01.title',
        text: 'accounts.cards.card_01.text',
        desc: 'accounts.cards.card_01.desc',
        classes: 'col-start-1 col-end-1 row-start-1 row-end-1',
    },
    {
        subtitle: 'accounts.cards.card_02.title',
        text: 'accounts.cards.card_02.text',
        classes: 'col-start-1 col-end-1 row-start-2 row-end-2',
    },
    {
        subtitle: 'accounts.cards.card_03.title',
        text: 'accounts.cards.card_03.text',
        desc: 'accounts.cards.card_03.desc',
        classes: 'col-start-3 col-end-3 row-start-1 row-end-3',
    },
];

const Cards = () => {
    const { t } = useTranslation();
    return (
        <section className="open-sans relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <div className="flex flex-col lg:grid grid-cols-3 gap-[15px] lg:gap-[20px]">
                    <div className="hidden items-end min-h-[250px] md:min-h-[unset] mb-[25px] md:mb-0 px-[20px] sm:py-[24px] py-[15px] col-start-2 col-end-2 row-start-1 row-end-3 sm:rounded-[20px] w-[calc(100%+40px)] ml-[-20px] sm:w-[100%] sm:ml-0 relative overflow-hidden lg:flex bg-[#CEDFF2]">
                        <img className="absolute z-[1] inset-[0] w-[100%] h-[100%] object-cover object-center" src={image} alt='' />
                    </div>
                    {cards.map((card, index) =>
                        <div
                            className={`${card.classes} xl:p-[30px] p-[20px] pb-[13px] md:rounded-[20px] rounded-[10px] md:min-h-[206px] min-h-[147px] bg-[#fff] flex flex-col justify-between gap-[30px]`}
                            key={index}
                        >
                            <div className="flex gap-[14px]">
                                <div className="xl:mt-[13px] sm:mt-[9px] mt-[6px] w-[12px] h-[12px] rounded-[100px] bg-[#CEDFF2] flex-shrink-0"></div>
                                <div>
                                    <h4 className="text-[#0C2780] font-[600] xl:text-[26px] sm:text-[20px] text-[16px]">
                                        {t(card.subtitle)}
                                    </h4>
                                    <p className="sm:mt-[15px] mt-[13px] sm:text-[16px] text-[14px] font-[400] text-[#0C2780]">
                                        {t(card.text)}
                                    </p>
                                </div>
                            </div>
                            <p className="text-right sm:text-[14px] text-[12px] font-[400] text-[#000E59]">
                                {t(card.desc)}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
};

export default Cards;
